import { TollDomainApi, DatsApi } from 'ctp-toll-domain';
import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

const apiConfig = {
  accessToken: () => userManager.getApiKey().replace('Bearer ', '')
};

export const TollDomainApiCaller = new TollDomainApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export const DatsApiCaller = new DatsApi(
  apiConfig,
  routes.apiRoutes.basePath
);

export default { TollDomainApiCaller, DatsApiCaller };
